import {
  RecommendationSlider,
  onRecommendedProductClick,
  handlePDPAnalyticsGlobal,
  onRecommendedProductSwatchClick,
  onSwatchClickHandler,
} from '@xp-utilities/web';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import handleAlgonomyProductClick from '../../tools/handleAlgonomyProductClick';
import RecommendedPlacementType from '../types/RecommendationsTypes/RecommendedPlacementType';

export default function HomePageRecommendationSliderPortal({
  matchingPlacement, aemPlacementData, aemTargetNode, portalKey,
}) {
  const { id, products, title } = matchingPlacement;

  const handleOnProductClick = useCallback(
    (...args) => {
      const [event, product] = args;
      onRecommendedProductClick(matchingPlacement, ...args);
      handlePDPAnalyticsGlobal(aemPlacementData, matchingPlacement, ...args);
      handleAlgonomyProductClick(event, product);
    },
    [matchingPlacement, aemPlacementData],
  );

  const handleOnSwatchClick = useCallback(
    (...args) => {
      onRecommendedProductSwatchClick(matchingPlacement, ...args);
      onSwatchClickHandler(...args);
    },
    [matchingPlacement],
  );

  return createPortal(
    <RecommendationSlider
      key={id}
      onProductClick={handleOnProductClick}
      onSwatchClick={handleOnSwatchClick}
      placement={id}
      products={products}
      title={title}
    />,
    aemTargetNode,
    portalKey,
  );
}

HomePageRecommendationSliderPortal.propTypes = {
  matchingPlacement: RecommendedPlacementType.isRequired,
  aemPlacementData: PropTypes.arrayOf(RecommendedPlacementType).isRequired,
  aemTargetNode: PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element).isRequired,
  portalKey: PropTypes.string.isRequired,
};
